// src/components/common/LanguageSwitcher.jsx
import React, { useState } from 'react';
import { changeLanguage } from '../../i18n/i18n';
import { useTranslation } from 'react-i18next';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

const LANGUAGES = [
    { code: 'it', label: 'Italiano', flag: '🇮🇹' },
    { code: 'fr', label: 'Français', flag: '🇫🇷' },
    { code: 'en', label: 'English', flag: '🇬🇧' },
];

const LanguageSwitcher = ({ compact = false }) => {
    const { i18n } = useTranslation();
    const [open, setOpen] = useState(false);
    const current = LANGUAGES.find(l => l.code === i18n.language) || LANGUAGES[0];

    const handleChange = (code) => {
        changeLanguage(code);
        setOpen(false);
    };

    if (compact) {
        return (
            <div className="flex gap-1">
                {LANGUAGES.map(lang => (
                    <button key={lang.code} onClick={() => handleChange(lang.code)}
                        className={`px-2 py-1 rounded-lg text-xs font-medium transition ${i18n.language === lang.code ? 'bg-blue-100 text-blue-700' : 'text-gray-500 hover:bg-gray-100'
                            }`} title={lang.label}>
                        {lang.flag}
                    </button>
                ))}
            </div>
        );
    }

    return (
        <div className="relative">
            <button onClick={() => setOpen(!open)}
                className="flex items-center gap-2 px-3 py-2 border border-gray-200 rounded-xl text-sm text-gray-700 hover:bg-gray-50 transition">
                <span>{current.flag}</span>
                <span className="font-medium">{current.label}</span>
                <ChevronDownIcon className={`w-3.5 h-3.5 text-gray-400 transition-transform ${open ? 'rotate-180' : ''}`} />
            </button>
            {open && (
                <div className="absolute right-0 top-full mt-1.5 w-40 bg-white border border-gray-100 rounded-xl shadow-lg z-20 overflow-hidden">
                    {LANGUAGES.map(lang => (
                        <button key={lang.code} onClick={() => handleChange(lang.code)}
                            className={`w-full flex items-center gap-2.5 px-3 py-2.5 text-sm text-left transition ${i18n.language === lang.code ? 'bg-blue-50 text-blue-700 font-semibold' : 'text-gray-700 hover:bg-gray-50'
                                }`}>
                            <span className="text-base">{lang.flag}</span>
                            {lang.label}
                            {i18n.language === lang.code && <span className="ml-auto text-blue-500 text-xs">✓</span>}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default LanguageSwitcher;